import React, { useCallback, useContext, useState } from 'react';
import { CarouselNav } from '../../CarouselNav';
import { Wrapper } from './ui/Layout';
import { useCategories } from './useCategories';
import { Categories } from './Categories';
import { EmblaCarousel } from '../EmblaCarousel';
import { VideoCarouselSlide } from '../EmblaCarousel/VideoSlide';
import { CompactViewContext } from '../Providers/CompactViewProvider';
export const FullWidthVideoCarousel = ({ videos, useControlNumbers = true, numberOfVideosToShow = 5, ...props }) => {
    const { categories } = useCategories(videos);
    const [videoIdx, setVideoIdx] = useState(0);
    const { isCompact } = useContext(CompactViewContext);
    const scrollPrev = useCallback(() => {
        if (isCompact) {
            setVideoIdx((videoIdx - 1 + videos.length) % videos.length);
        }
        else {
            setVideoIdx((videoIdx - 2 + videos.length) % videos.length);
        }
    }, [isCompact, videos.length, videoIdx, setVideoIdx]);
    const scrollNext = useCallback(() => {
        if (isCompact) {
            setVideoIdx((videoIdx + 1) % videos.length);
        }
        else {
            setVideoIdx((videoIdx + 2) % videos.length);
        }
    }, [isCompact, videos.length, videoIdx, setVideoIdx]);
    const onCategoryClick = useCallback((cat) => {
        const number = videos.findIndex(v => v.category === cat);
        setVideoIdx(number);
    }, [videos, setVideoIdx]);
    return (React.createElement(Wrapper, null,
        categories && (React.createElement(Categories, { categories: categories, currentCategory: videos[videoIdx].category, onClick: onCategoryClick })),
        React.createElement(EmblaCarousel, { ...props, slides: videos, numberOfSlidesToShow: numberOfVideosToShow, videoIdx: videoIdx, setVideoIdx: n => {
                setVideoIdx((n + videos.length) % videos.length);
            }, scrollNext: scrollNext, scrollPrev: scrollPrev, renderSlide: ({ vid, idx, affordanceState, hasInteracted }) => (React.createElement(VideoCarouselSlide, { video: vid, affordanceState: affordanceState, isCurrent: idx === videoIdx, hasInteracted: hasInteracted })) }),
        React.createElement(CarouselNav, { handlePrev: () => scrollPrev(), handleNext: () => scrollNext(), allowLooping: true, index: videoIdx + 1, total: videos.length, useControlNumbers: isCompact || useControlNumbers })));
};
